<template>
  <div id="mtm" class="col-sm-12 container-fluid bg-light mt-5 mb-5 container-mtm">
    <div class="panel panel-default m-2">
      <div v-if="hayCambios"
        class="bg-success-changes rounded-0 d-flex justify-content-between fs-12 font-weight-bold m-0 align-items-center flex-column-changes">
        <div class="ml-2">
          <p class="mt-3">¡Nuevos cambios detectados!</p>
        </div>
        <div class="mr-2">
          <button type="button" class="btn btn-md btn-dark me-0 mb-2 mt-2" @click="consultar_matriz_peligro_cliente()"
            :disabled="isLoading">
            <i class="fas fa-sync mr-1"></i>Refrescar Tabla
          </button>
        </div>
      </div>
      <vue-good-table :columns="columns" :rows="$store.state.global_matriz_peligro_cliente" max-height="620px"
        :isLoading="isLoading" :pagination-options="{
          enabled: true,
          mode: 'records',
          jumpFirstOrLast: true,
          perPage: 10,
          setCurrentPage: 1,
          rowsPerPageLabel: 'Registros',
          firstLabel: 'Primera',
          lastLabel: 'Última',
          nextLabel: 'Sig.',
          prevLabel: 'Ant.',
          ofLabel: 'de',
          allLabel: 'Todos',
          dropdownAllowAll: false,
        }">
        <div slot="emptystate" class="text-center">
          <template v-if="isLoading">
            Cargando...
          </template>
          <template v-else>
            No se encontraron registros
          </template>
        </div>
        <div></div>
        <div slot="loadingContent">
          <div class="bg-gray-800 rounded">
            <h3 class="text-4xl" style="color: #e8640c">
              <i class="fas fa-circle-notch fa-spin" style="font-size: 25pt"></i>
            </h3>
          </div>
        </div>
        <template slot="table-row" slot-scope="props">
          <!-- OPCIONES -->
          <div v-if="props.column.field == 'opciones'">
            <div v-for="(item, index) in props.row.lista_peligros" :key="index.item">
              <button class="btn btn-block dropdown-toggle btn-danger rounded-pill" data-toggle="dropdown"
                aria-expanded="false" :disabled="$store.state.global_nuevo_peligro ||
                  $store.state.global_es_editar
                  "></button>
              <ul class="dropdown-menu" role="menu">
                <li>
                  <a class="btn btn-block mi_boton" @click="editar_peligro(item.id_matriz)">&nbsp;<b>Editar
                      Peligro</b></a>
                </li>
                <li>
                  <a class="btn btn-block mi_boton" @click="
                    nuevo_peligro(
                      props.row.id_proceso,
                      props.row.proceso_riesgo,
                      props.row.id_zona,
                      props.row.zona,
                      props.row.id_actividad,
                      props.row.actividad,
                      props.row.id_tareas,
                      props.row.tarea,
                      props.row.rutinario_peligro
                    )
                    ">&nbsp;<b>Nuevo Peligro</b></a>
                </li>
                <li>
                  <a class="btn btn-block mi_boton" @click="eliminar_peligro(item.id_matriz)">&nbsp;<b>Eliminar
                      Peligro</b></a>
                </li>
                <li>
                  <a class="btn btn-block mi_boton" @click="
                    eliminar_proceso(
                      props.row.id_proceso,
                      props.row.id_zona,
                      props.row.id_actividad,
                      props.row.id_tareas
                    )
                    ">&nbsp;<b>Eliminar Proceso</b></a>
                </li>
              </ul>
            </div>
          </div>
          <!-- PROCESO -->
          <div v-else-if="props.column.field == 'filtros.proceso'">
            <p>
              <b style="color: #e8640c">Proceso: </b> {{ props.row.proceso_riesgo }}
            </p>
            <p>
              <b style="color: #e8640c">Zona: </b> {{ props.row.zona }}
            </p>
            <p>
              <b style="color: #e8640c">Actividades: </b> {{ props.row.actividad }}
            </p>
            <p>
              <b style="color: #e8640c">Tareas: </b> {{ props.row.tarea }}
            </p>
            <p class="mb-0">
              <b style="color: #e8640c">Rutinario: </b> {{ props.row.rutinario_peligro }}
            </p>
          </div>
          <!-- PELIGRO -->
          <div v-else-if="props.column.field == 'lista_peligros'">
            <div v-for="(item, index) in props.row.lista_peligros" :key="index.item">
              <!-- CLASIFICACIÓN -->
              <p>
                <b style="color: #e8640c">Clasificación: </b> {{ item.clasificacion }}
              </p>
              <!-- SUBCLASIFICACIÓN -->
              <p>
                <b style="color: #e8640c">Subclasificación: </b> {{ item.subclasificacion }}
              </p>
              <!-- DESCRIPCIÓN -->
              <p class="mb-0">
                <b style="color: #e8640c">Descripción: </b> {{ item.descripcion }}
              </p>
            </div>
          </div>
          <!-- EFECTOS POSIBLES -->
          <div v-else-if="props.column.field === 'filtros.efectos_posibles'">
            <div v-for="(item, index) in props.row.lista_peligros" :key="index.item">
              <p>{{ item.efecto_posible }}</p>
            </div>
          </div>
          <!-- CONTROLES EXISTENTES -->
          <div v-else-if="props.column.field === 'controles_existentes'">
            <div v-for="(item, index) in props.row.lista_peligros" :key="index.item">
              <!-- FUENTE -->
              <button type="button" class="btn btn-sm btn_general font-weight-bold" :style="[
                item.fuente != ''
                  ? {
                    backgroundColor: '#e8640c !important',
                    textAlign: 'center !important',
                    color: '#ffffff !important',
                    width: '100%',
                    margin: '2.5px',
                  }
                  : {
                    backgroundColor: '#2b4c9b !important',
                    textAlign: 'center !important',
                    color: '#ffffff !important',
                    width: '100%',
                    margin: '2.5px',
                  },
              ]" @click="mostrar_controles_fuente(item.id_matriz)" data-toggle="modal"
                data-target="#modal_controles_existentes_fuente">
                Fuente
              </button>
              <!-- MEDIO -->
              <button type="button" class="btn btn-sm btn_general font-weight-bold" :style="[
                item.medio != ''
                  ? {
                    backgroundColor: '#e8640c !important',
                    textAlign: 'center !important',
                    color: '#ffffff !important',
                    width: '100%',
                    margin: '2.5px',
                  }
                  : {
                    backgroundColor: '#2b4c9b !important',
                    textAlign: 'center !important',
                    color: '#ffffff !important',
                    width: '100%',
                    margin: '2.5px',
                  },
              ]" @click="mostrar_controles_medio(item.id_matriz)" data-toggle="modal"
                data-target="#modal_controles_existentes_medio">
                Medio
              </button>
              <!-- INDIVIDUO -->
              <button type="button" class="btn btn-sm btn_general font-weight-bold" :style="[
                item.individuo != ''
                  ? {
                    backgroundColor: '#e8640c !important',
                    textAlign: 'center !important',
                    color: '#ffffff !important',
                    width: '100%',
                    margin: '2.5px',
                  }
                  : {
                    backgroundColor: '#2b4c9b !important',
                    textAlign: 'center !important',
                    color: '#ffffff !important',
                    width: '100%',
                    margin: '2.5px',
                  },
              ]" @click="mostrar_controles_individuo(item.id_matriz)" data-toggle="modal"
                data-target="#modal_controles_existentes_individuo">
                Individuo
              </button>
            </div>
          </div>
          <!-- EVALUACIÓN DE RIESGO -->
          <div v-else-if="props.column.field === 'filtros.evaluacion_riesgo'">
            <div v-for="(item, index) in props.row.lista_peligros" :key="index.item">
              <button type="text" class="btn btn-sm btn_general font-weight-bold" :style="item.class_btn_alerts" @click="
                consultar_evaluacion_riesgo(
                  item.id_matriz,
                  item.class_btn_outline,
                  item.class_btn_alerts
                )
                " readonly required data-toggle="modal">
                {{ item.aceptabilidad }}
              </button>
            </div>
          </div>
          <!-- CRITERIOS DE CONTROLES -->
          <div v-else-if="props.column.field === 'filtros.criterios_controles'">
            <div v-for="(item, index) in props.row.lista_peligros" :key="index">
              <p>
                <b style="color: #e8640c">Expuestos: </b> {{ item.num_expuestos }}
              </p>
              <p>
                <b style="color: #e8640c">Requisito Legal: </b> {{ item.requisito_legal }}
              </p>
              <p class="mb-0">
                <b style="color: #e8640c">Peor Consecuencia: </b> {{ item.peor_consecuencia }}
              </p>
            </div>
          </div>
          <!-- MEDIDAS DE INTERVENCIÓN -->
          <div v-else-if="props.column.field === 'medidas_intervencion'">
            <div v-for="(item, index) in props.row.lista_peligros" :key="index.item">
              <!-- ELIMINACIÓN -->
              <button type="button" class="btn btn-sm btn_general font-weight-bold" :style="[
                item.eliminacion != ''
                  ? {
                    backgroundColor: '#e8640c !important',
                    textAlign: 'center !important',
                    color: '#ffffff !important',
                    width: '100%',
                    margin: '2.5px',
                  }
                  : {
                    backgroundColor: '#2b4c9b !important',
                    textAlign: 'center !important',
                    color: '#ffffff !important',
                    width: '100%',
                    margin: '2.5px',
                  },
              ]" @click="consultar_medidas_intervencion_eliminacion(item.id_matriz)" data-toggle="modal"
                data-target="#modal_medidas_intervencion_eliminacion">
                Eliminación
              </button>
              <!-- SUSTITUCIÓN -->
              <button type="button" class="btn btn-sm btn_general font-weight-bold" :style="[
                item.sustitucion != ''
                  ? {
                    backgroundColor: '#e8640c !important',
                    textAlign: 'center !important',
                    color: '#ffffff !important',
                    width: '100%',
                    margin: '2.5px',
                  }
                  : {
                    backgroundColor: '#2b4c9b !important',
                    textAlign: 'center !important',
                    color: '#ffffff !important',
                    width: '100%',
                    margin: '2.5px',
                  },
              ]" @click="
                consultar_medidas_intervencion_sustitucion(
                  item.id_matriz
                )
                " data-toggle="modal" data-target="#modal_medidas_intervencion_sustitucion">
                Sustitución
              </button>
              <!-- CONTROLES DE INGENIERÍA -->
              <button type="button" class="btn btn-sm btn_general font-weight-bold" :style="[
                item.controles_ing != ''
                  ? {
                    backgroundColor: '#e8640c !important',
                    textAlign: 'center !important',
                    color: '#ffffff !important',
                    width: '100%',
                    margin: '2.5px',
                  }
                  : {
                    backgroundColor: '#2b4c9b !important',
                    textAlign: 'center !important',
                    color: '#ffffff !important',
                    width: '100%',
                    margin: '2.5px',
                  },
              ]" @click="
                consultar_medidas_intervencion_controles(item.id_matriz)
                " data-toggle="modal" data-target="#modal_medidas_intervencion_controles">
                Controles de Ingeniería
              </button>
              <!-- CONTROLES ADMINISTRATIVOS -->
              <button type="button" class="btn btn-sm btn_general font-weight-bold" :style="[
                item.controles_admin != ''
                  ? {
                    backgroundColor: '#e8640c !important',
                    textAlign: 'center !important',
                    color: '#ffffff !important',
                    width: '100%',
                    margin: '2.5px',
                  }
                  : {
                    backgroundColor: '#2b4c9b !important',
                    textAlign: 'center !important',
                    color: '#ffffff !important',
                    width: '100%',
                    margin: '2.5px',
                  },
              ]" @click="
                consultar_medidas_intervencion_controles_admin(
                  item.id_matriz
                )
                " data-toggle="modal" data-target="#modal_medidas_intervencion_controles_admin">
                Controles Administrativos
              </button>
              <!-- ELEMENTOS DE PROTECCIÓN PERSONAL -->
              <button type="button" class="btn btn-sm btn_general font-weight-bold" :style="[
                item.equipos != ''
                  ? {
                    backgroundColor: '#e8640c !important',
                    textAlign: 'center !important',
                    color: '#ffffff !important',
                    width: '100%',
                    margin: '2.5px',
                  }
                  : {
                    backgroundColor: '#2b4c9b !important',
                    textAlign: 'center !important',
                    color: '#ffffff !important',
                    width: '100%',
                    margin: '2.5px',
                  },
              ]" @click="
                consultar_medidas_intervencion_equipos(item.id_matriz)
                " data-toggle="modal" data-target="#modal_medidas_intervencion_equipos">
                Elementos de Protección Personal
              </button>
            </div>
          </div>
        </template>
      </vue-good-table>
    </div>
    <!-- MODALES PARA USO DE LA TABLA-->
    <!-- MODAL FUENTE -->
    <div class="modal fade" id="modal_controles_existentes_fuente" tabindex="-1" role="dialog"
      aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row justify-content-center">
              <h3 class="letra-sm-modal mb-3"><b>Fuente</b></h3>
              <div v-if="fuente_checked != ''" class="col-sm-12">
                <p>{{ fuente_checked }}</p>
              </div>
              <div v-else class="col-sm-12">
                <p>Sin datos.</p>
              </div>
            </div>
            <div class="row justify-content-center">
              <button type="button" class="btn btn-secondary" data-dismiss="modal" aria-label="Close">
                Cerrar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- MODAL MEDIO -->
    <div class="modal fade" id="modal_controles_existentes_medio" tabindex="-1" role="dialog"
      aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row justify-content-center">
              <h3 class="letra-sm-modal mb-3"><b>Medio</b></h3>
              <div v-if="medio_checked != ''" class="col-sm-12">
                <p>{{ medio_checked }}</p>
              </div>
              <div v-else class="col-sm-12">
                <p>Sin datos.</p>
              </div>
            </div>
            <div class="row justify-content-center">
              <button type="button" class="btn btn-secondary" data-dismiss="modal" aria-label="Close">
                Cerrar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- MODAL INDIVIDUO -->
    <div class="modal fade" id="modal_controles_existentes_individuo" tabindex="-1" role="dialog"
      aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row justify-content-center">
              <h3 class="letra-sm-modal mb-3"><b>Individuo</b></h3>
              <div v-if="individuo_checked != ''" class="col-sm-12">
                <p>{{ individuo_checked }}</p>
              </div>
              <div v-else class="col-sm-12">
                <p>Sin datos.</p>
              </div>
            </div>
            <div class="row justify-content-center">
              <button type="button" class="btn btn-secondary" data-dismiss="modal" aria-label="Close">
                Cerrar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- MODAL EVALUACIÓN RIESGO -->
    <div class="container">
      <div class="modal fade" id="modal_evaluacion_riesgo" tabindex="-1" role="dialog"
        aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h2 class="modal-title">Evaluacion Riesgo</h2>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body container-fluid">
              <div class="row justify-content-center">
                <h3>Probabilidad</h3>
              </div>
              <div class="row justify-content-center">
                <!-- ND -->
                <div class="col-md-4">
                  <label class="color_letra">Nivel de Deficiencia:</label>
                  <input type="text" class="form-control form-control-sm boton_texto" v-model="c_nivel_eficiencia"
                    title="NIVEL DE DEFICIENCIA
                                                    10: Pel. con consec. muy signi.
                                                        o la eficacia del conjunto de
                                                        medidas es nula, o ambos.
                                                    6: Pel. con consec. o la eficacia
                                                        del conjunto de medidas es bajo,
                                                        o ambos.
                                                    2: Pel. con consec. poco signi.
                                                        o la eficacia del conjunto de
                                                        medidas es moderado." disabled />
                </div>
                <!-- NE -->
                <div class="col-md-4">
                  <label class="color_letra">Nivel de Exposición:</label>
                  <input type="text" class="form-control form-control-sm boton_texto" v-model="c_nivel_exposicion"
                    title="NIVEL DE EXPOSICIÓN
                                                        4: Continua-Sin interrupción o
                                                        varias veces con tiempo prolongado
                                                        durante la jornada.
                                                        3: Frecuente-Varias veces durante
                                                        la jornada por tiempos cortos.
                                                        2: Ocasional-Algunas vez durante 
                                                        la jornada y por un periodo de
                                                        tiempo corto.
                                                        1: Esporádica-De manera eventual." disabled />
                </div>
                <!-- NP -->
                <div class="col-md-4">
                  <label class="color_letra">Nivel de Probabilidad:</label>
                  <input type="text" v-model="c_nivel_probabilidad" class="form-control form-control-sm boton_texto"
                    disabled />
                </div>
              </div>
              <div class="row justify-content-center">
                <!-- INTERPRETACIÓN -->
                <div class="col-md-4">
                  <br /><label class="color_letra">Interpretación del Nivel de Probabilidad:</label>
                  <input type="text" v-model="c_interpretacion" class="
                            form-control form-control-sm
                            btn_general
                            font-weight-bold
                          " :style="class_btn_outline" readonly required />
                </div>

                <!-- CONSECUENCIA -->
                <div class="col-md-4">
                  <br /><label class="color_letra">Nivel de Consecuencia:</label>
                  <input type="text" class="form-control form-control-sm boton_texto" v-model="c_nivel_consecuencia"
                    title="NIVEL DE CONSECUENCIA
                                                    100: Muerte(s).
                                                    60: Lesiones o enfermedades graves
                                                        irreparables (incapacidad permanente,
                                                        parcial o invalidez.
                                                    25:Lesiones o enfermedades con
                                                        incapacidad laboral temporal.
                                                    10: Lesiones o enfermedades que
                                                        no requieren incapacidad." disabled />
                </div>
                <!-- NR -->
                <div class="col-md-4">
                  <br /><label class="color_letra">Nivel de Riesgo (NR) e Intervención:</label>
                  <input type="text" class="form-control form-control-sm boton_texto" v-model="c_nivel_riesgo"
                    disabled />
                </div>
              </div>
              <div class="row justify-content-center">
                <!-- INTERPRETACIÓN NR -->
                <div class="col-md-5">
                  <br /><label class="color_letra">Interpretación del NR:</label>
                  <input type="text" v-model="c_interpretacion_nr" class="
                            form-control form-control-sm
                            btn_general
                            interpretacion-nr
                            font-weight-bold
                          " readonly />
                </div>
                <!-- VR -->
                <div class="col-md-7">
                  <br /><b><label class="color_letra">VALORACIÓN DEL RIESGO</label></b>&nbsp;&nbsp;
                  <label class="color_letra">Aceptabilidad del Riesgo:</label>
                  <input type="text" class="btn btn-sm btn_general font-weight-bold" v-model="c_aceptabilidad"
                    :style="class_btn_alerts" readonly required />
                </div>
              </div>
              <div class="row justify-content-center mt-4">
                <button class="btn btn-sm btn-form" data-dismiss="modal" aria-label="Close">
                  CERRAR
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- MODAL ELIMINACIÓN -->
    <div class="modal fade" id="modal_medidas_intervencion_eliminacion" tabindex="-1" role="dialog"
      aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row justify-content-center">
              <h3 class="letra-sm-modal mb-3"><b>Eliminación</b></h3>
              <div v-if="cm_eliminacion_checked != ''" class="col-sm-12">
                <p>{{ cm_eliminacion_checked }}</p>
              </div>
              <div v-else class="col-sm-12">
                <p>Sin datos.</p>
              </div>
            </div>
            <div class="row justify-content-center">
              <button type="button" class="btn btn-secondary" data-dismiss="modal" aria-label="Close">
                Cerrar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- MODAL SUSTITUCIÓN -->
    <div class="modal fade" id="modal_medidas_intervencion_sustitucion" tabindex="-1" role="dialog"
      aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row justify-content-center">
              <h3 class="letra-sm-modal mb-3"><b>Sustitución</b></h3>
              <div v-if="cm_sustitucion_checked != ''" class="col-sm-12">
                <p>{{ cm_sustitucion_checked }}</p>
              </div>
              <div v-else class="col-sm-12">
                <p>Sin datos.</p>
              </div>
            </div>
            <div class="row justify-content-center">
              <button type="button" class="btn btn-secondary" data-dismiss="modal" aria-label="Close">
                Cerrar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- MODAL CONTROLES INGENIERÍA -->
    <div class="modal fade" id="modal_medidas_intervencion_controles" tabindex="-1" role="dialog"
      aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row justify-content-center">
              <h3 class="letra-sm-modal mb-3">
                <b>Controles de Ingeniería</b>
              </h3>
              <div v-if="cm_controles_checked != ''" class="col-sm-12">
                <p>{{ cm_controles_checked }}</p>
              </div>
              <div v-else class="col-sm-12">
                <p>Sin datos.</p>
              </div>
            </div>
            <div class="row justify-content-center">
              <button type="button" class="btn btn-secondary" data-dismiss="modal" aria-label="Close">
                Cerrar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- MODAL CONTROLES ADMINISTRATIVOS -->
    <div class="modal fade" id="modal_medidas_intervencion_controles_admin" tabindex="-1" role="dialog"
      aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row justify-content-center">
              <h3 class="letra-sm-modal mb-3">
                <b>Controles Administrativos</b>
              </h3>
              <div v-if="cm_controles_admin_checked != ''" class="col-sm-12">
                <p>{{ cm_controles_admin_checked }}</p>
              </div>
              <div v-else class="col-sm-12">
                <p>Sin datos.</p>
              </div>
            </div>
            <div class="row justify-content-center">
              <button type="button" class="btn btn-secondary" data-dismiss="modal" aria-label="Close">
                Cerrar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- MODAL ELEMENTOS DE PROTECCIÓN PERSONAL -->
    <div class="modal fade" id="modal_medidas_intervencion_equipos" tabindex="-1" role="dialog"
      aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row justify-content-center">
              <h4 class="letra-sm-modal mb-3">
                <b>Elementos de Protección Personal</b>
              </h4>
              <div v-if="cm_equipos_checked != ''" class="col-sm-12">
                <p>{{ cm_equipos_checked }}</p>
              </div>
              <div v-else class="col-sm-12">
                <p>Sin datos.</p>
              </div>
            </div>
            <div class="row justify-content-center">
              <button type="button" class="btn btn-secondary" data-dismiss="modal" aria-label="Close">
                Cerrar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from "./../firebase";
import Swal from "sweetalert2";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import Vue from "vue";
import VueGoodTablePlugin from "vue-good-table";
import "vue-good-table/dist/vue-good-table.css";
import _ from "lodash";
Vue.use(VueGoodTablePlugin);
export default {
  name: "mtm",

  data() {
    return {
      // CONTROLES EXISTENTES
      fuente_checked: [],
      medio_checked: [],
      individuo_checked: [],

      // MEDIDAS DE INTERVENCIÓN
      cm_eliminacion: [],
      cm_eliminacion_checked: [],
      cm_sustitucion: [],
      cm_sustitucion_checked: [],
      cm_controles: [],
      cm_controles_checked: [],
      cm_controles_admin: [],
      cm_controles_admin_checked: [],
      cm_equipos: [],
      cm_equipos_checked: [],

      otro_elim: "",
      otro_sus: "",
      otro_c_ing: "",
      otro_senal: "",
      otro_epp: "",

      // TABLA MATRIZ DE RIESGO
      /*columns: [
        "proceso_riesgo",
        "peligro",
        "e_efecto_posible",
        "controles_existentes",
        "evaluacion_riesgo",
        "criterios_controles",
        "medidas_intervencion",
        "opciones",
      ],
      options: {
        headings: {
          proceso_riesgo: "Proceso",
          peligro: "Peligro",
          e_efecto_posible: "Efectos Posibles",
          controles_existentes: "Controles Existentes",
          evaluacion_riesgo: "Evaluacion del Riesgo",
          criterios_controles: "Criterios Controles",
          medidas_intervencion: "Medidas Intervención",
          opciones: "Opciones",
        },
        sortable: ["proceso_riesgo", "zona", "actividad", "tarea"],
        texts: {
          filter: "Buscar",
          filterPlaceholder: " ",
        },
      },

      columnsMovil: ["procesoMovil"],
      optionsMovil: {
        headings: {
          procesoMovil: "",
        },
        sortable: ["procesoMovil"],
        texts: {
          filter: "Buscar",
          filterPlaceholder: "",
        },
        filterAlgorithm: {
          movil(row, query) {
            return (
              row.proceso_riesgo +
              " " +
              row.peligro +
              " " +
              row.e_efecto_posible +
              " " +
              row.controles_existentes +
              " " +
              row.evaluacion_riesgo +
              " " +
              row.criterios_controles +
              " " +
              row.medidas_intervencion
            ).includes(query);
          },
        },
        skin: "table table-condensed",
      },*/
      hayCambios: false,
      columns: [
        {
          label: "OPCIONES",
          field: "opciones",
          thClass: "text-center",
          tdClass: "text-center align-middle",
          width: "150px",
        },
        {
          label: "PROCESO",
          field: "filtros.proceso",
          width: "300px",
          thClass: "text-center",
          tdClass: "align-middle",
          filterOptions: {
            enabled: true,
            placeholder: "FILTRAR",
            filterFn: this.filtroProceso,
          },
        },
        {
          label: "PELIGRO",
          field: "lista_peligros",
          width: "300px",
          thClass: "text-center",
          tdClass: "align-middle",
          filterOptions: {
            enabled: true,
            placeholder: "FILTRAR",
            filterFn: this.filtroPeligro,
          },
        },
        {
          label: "EFECTOS POSIBLES",
          field: "filtros.efectos_posibles",
          width: "300px",
          thClass: "text-center",
          tdClass: "align-middle",
          filterOptions: {
            enabled: true,
            placeholder: "FILTRAR"
          },
        },
        {
          label: "CONTROLES EXISTENTES",
          field: "controles_existentes",
          width: "250px",
          thClass: "text-center",
          tdClass: "text-center align-middle",
          filterOptions: {
            enabled: false,
            placeholder: "FILTRAR",
          },
        },
        {
          label: "EVALUACIÓN DEL RIESGO",
          field: "filtros.evaluacion_riesgo",
          width: "280px",
          thClass: "text-center",
          tdClass: "text-center align-middle",
          filterOptions: {
            enabled: true,
            placeholder: "FILTRAR",
            filterDropdownItems: ["Pendiente", "Aceptable", "Mejorable", "Aceptable con Control Específico", "No Aceptable"]
          },
        },
        {
          label: "CRITERIOS DE CONTROLES",
          field: "filtros.criterios_controles",
          width: "250px",
          thClass: "text-center",
          tdClass: "align-middle",
          filterOptions: {
            enabled: true,
            placeholder: "FILTRAR",
            filterFn: this.filtroCriterios,
          },
        },
        {
          label: "MEDIDAS DE INTERVENCIÓN",
          field: "medidas_intervencion",
          width: "250px",
          thClass: "text-center",
          tdClass: "text-center align-middle",
          filterOptions: {
            enabled: false,
            placeholder: "FILTRAR",
          },
        }
      ],
      isLoading: false,

      // EVALUACIÓN DEL RIESGO
      c_nivel_eficiencia: null,
      c_nivel_consecuencia: null,
      c_nivel_exposicion: null,
      c_nivel_probabilidad: null,
      c_interpretacion: null,

      c_nivel_riesgo: null,
      c_interpretacion_nr: null,
      c_aceptabilidad: null,

      class_btn_alerts: {
        border: "",
        textAlign: "center",
        color: "",
        width: "100%",
      },
      class_btn_alerts_m: {
        border: "",
        textAlign: "center",
        color: "",
        width: "100%",
      },
      class_btn_alerts_movil: {
        border: "",
        textAlign: "center",
        color: "",
        width: "70%",
      },
      class_btn_outline: {
        border: "",
        textAlign: "center",
        color: "",
      },
      class_btn_outline_m: {
        border: "",
        textAlign: "center",
        color: "",
      },

      // IDS LOCALES
      local_id_matriz_riesgo: "",

      // CRITERIOS CONTROLES
      c_num_expuestos: 0,
      c_peor_consecuencia: "",

      // VARIABLES PARA LA VERSIÓN MÓVIL
      lista_peligros_movil: [],
      id_matriz_movil: "",
      id_peligro_movil: "",
      clasificacion_movil: "",
      id_subcla_movil: "",
      subclasificacion_movil: "",
      descripcion_movil: "",
      id_efectos_posibles_movil: "",
      efecto_posible_movil: "",
      fuente_movil: "",
      medio_movil: "",
      individuo_movil: "",
      antecedente_movil: "",
      class_btn_outline_movil: "",
      class_btn_alerts_movil: "",
      aceptabilidad_movil: "",
      num_expuestos_movil: "",
      peor_consecuencia_movil: "",
      requisito_legal_movil: "",
      eliminacion_movil: "",
      equipos_movil: "",
      sustitucion_movil: "",
      controles_ing_movil: "",
      controles_admin_movil: "",

      id_proceso_movil: "",
      id_zona_movil: "",
      id_actividad_movil: "",
      id_tareas_movil: "",
      proceso_riesgo_movil: "",
      zona_movil: "",
      actividad_movil: "",
      tarea_movil: "",
      rutinario_peligro_movil: "",
    };
  },

  async created() {
    /*if (!this.$store.state.global_llenar_matriz_peligros) {
      this.consultar_matriz_peligro_cliente();
      $(".carousel").carousel("pause");
    }
    EventBus.$on("cargar_tabla", () => {
      if (this.$store.state.global_llenar_matriz_peligros) {
        $(".carousel").carousel("pause");
        this.consultar_matriz_peligro_cliente();
        this.$store.state.global_llenar_matriz_peligros = false;
      }
    });
    $(".carousel").carousel("pause");*/
    await this.consultar_matriz_peligro_cliente();
  },

  methods: {
    async consultar_matriz_peligro_cliente() {
      if (this.$store.state.msp_c_key) {
        /* OBTENER ÚLTIMAS ACTUALIZACIONES */
        this.$store.state.global_matriz_peligro_cliente = [];
        this.isLoading = true;
        const q = db.collection("matriz_riesgo")
          .where("em_id_cliente", "==", this.$store.state.msp_c_key)
          .orderBy("em_fecha_registro", "desc");
        const querySnapshot = [];
        await q.get().then((registros) => {
          registros.forEach((doc) => {
            querySnapshot.push(doc);
          });
        });
        this.$store.state.global_matriz_peligro_cliente = await Promise.all(
          querySnapshot.map(async (doc) => {
            const proceso = {
              nombre: doc.data().em_proceso,
              zona: doc.data().em_zona,
              actividad: doc.data().em_actividad,
              tarea: Array.isArray(doc.data().em_tarea) ? array_tareas.map((i) => ` ${i}`).toString() : doc.data().em_tarea,
              rutinario_peligro: doc.data().em_rutinario ? "Si" : "No",
            };
            const efectos_posibles = doc.data().em_efecto_posible ? doc.data().em_efecto_posible.map((i) => ` ${i}`).toString() : [];
            const criterios_controles = {
              num_expuestos: doc.data().em_num_expuestos,
              peor_consecuencia: doc.data().em_peor_consecuencia,
              requisito_legal: doc.data().em_requisito_legal ? "Si" : "No",
            }
            return {
              //id: doc.id,
              id_cliente_iper: doc.data().em_id_cliente_iper,
              id_cliente: doc.data().em_id_cliente,
              id_proceso: doc.data().em_id_proceso,
              id_zona: doc.data().em_id_zona,
              id_actividad: doc.data().em_id_acti,
              id_tareas: doc.data().em_id_tareas,
              proceso_riesgo: proceso.nombre,
              zona: proceso.zona,
              actividad: proceso.actividad,
              tarea: proceso.tarea,
              rutinario_peligro: proceso.rutinario_peligro,
              filtros: {
                proceso: proceso,
                efectos_posibles: efectos_posibles,
                evaluacion_riesgo: doc.data().em_aceptabilidad ? doc.data().em_aceptabilidad : "Pendiente",
                criterios_controles: criterios_controles
              },
              lista_peligros: [
                {
                  id_matriz: doc.id,
                  id_peligro: doc.data().em_id_peligro,
                  clasificacion: doc.data().em_clasificacion,
                  id_subcla: doc.data().em_id_subclasificacion,
                  subclasificacion: doc.data().em_tipo,
                  descripcion: doc.data().em_descripcion,
                  id_efectos_posibles: doc.data().em_id_efectos_posibles,
                  efecto_posible: efectos_posibles,
                  fuente: doc.data().em_c_fuente,
                  medio: doc.data().em_c_medio,
                  individuo: doc.data().em_c_individuo,
                  antecedente: doc.data().em_antecedente,
                  aceptabilidad: doc.data().em_aceptabilidad ? doc.data().em_aceptabilidad : "Pendiente",
                  class_btn_outline: {
                    border: doc.data().c_interpretacion === "Muy alto" ? "3px solid #d9534f" :
                      doc.data().c_interpretacion === "Alto" ? "3px solid #f0ad4e" :
                        (doc.data().c_interpretacion === "Medio" || doc.data().c_interpretacion === "Bajo") ? "3px solid #5cb85c" :
                          !doc.data().em_aceptabilidad ? "3px solid #5bc0de" : "3px solid #5bc0de",
                    textAlign: "center",
                    color: doc.data().c_interpretacion === "Muy alto" ? "#d9534f" :
                      doc.data().c_interpretacion === "Alto" ? "#f0ad4e" :
                        (doc.data().c_interpretacion === "Medio" || doc.data().c_interpretacion === "Bajo") ? "#5cb85c" :
                          !doc.data().em_aceptabilidad ? "#5bc0de" : "#5bc0de",
                  },
                  class_btn_alerts: {
                    border: doc.data().em_aceptabilidad === "No Aceptable" ? "3px solid #d9534f" :
                      doc.data().em_aceptabilidad === "Aceptable con Control Específico" ? "3px solid #f0ad4e" :
                        (doc.data().em_aceptabilidad === "Mejorable" || doc.data().em_aceptabilidad === "Aceptable") ? "3px solid #5cb85c" : "3px solid #5bc0de",
                    textAlign: "center",
                    color: doc.data().em_aceptabilidad === "No Aceptable" ? "#d9534f" :
                      doc.data().em_aceptabilidad === "Aceptable con Control Específico" ? "#f0ad4e" :
                        (doc.data().em_aceptabilidad === "Mejorable" || doc.data().em_aceptabilidad === "Aceptable") ? "#5cb85c" : "#5bc0de",
                    width: "100%",
                  },
                  num_expuestos: criterios_controles.num_expuestos,
                  peor_consecuencia: criterios_controles.peor_consecuencia,
                  requisito_legal: criterios_controles.requisito_legal,
                  eliminacion: doc.data().em_eliminacion ? doc.data().em_eliminacion : [],
                  sustitucion: doc.data().em_sustitucion ? doc.data().em_sustitucion : [],
                  controles_ing: doc.data().em_controles_ing ? doc.data().em_controles_ing : doc.data().em_control_ingenieria ? doc.data().em_control_ingenieria : [],
                  controles_admin: doc.data().em_controles ? doc.data().em_controles : doc.data().em_controles_admin ? doc.data().em_controles_admin : [],
                  equipos: doc.data().em_equipos ? doc.data().em_equipos : doc.data().em_epp ? doc.data().em_epp : [],
                },
              ],
            }
          })
        );
        const set = new Set(this.$store.state.global_matriz_peligro_cliente.map(JSON.stringify));
        this.$store.state.global_matriz_peligro_cliente = Array.from(set).map(JSON.parse);

        /* COPIAR CONSULTA PARA COMPARAR CAMBIOS */
        const copia = await Promise.all(
          querySnapshot.map((doc) => {
            return { ...doc.data() }
          })
        );
        this.isLoading = false;

        /* DETECTAR ULTIMOS CAMBIOS */
        let cambios = [];
        q.onSnapshot((snapshot) => {
          snapshot.docChanges().forEach((change) => {
            if (change.type === 'added' || change.type === 'modified') {
              cambios.push(change.doc.data());
            } else if (change.type === "removed") {
              for (let index = 0; index < this.$store.state.global_matriz_peligro_cliente.length; index++) {
                if (change.doc.id == this.$store.state.global_matriz_peligro_cliente[index].lista_peligros[0].id_matriz) {
                  this.$store.state.global_matriz_peligro_cliente.splice(index, 1);
                }
              }
            }
          });
          if (!_.isMatch([copia], [cambios]) && _.isMatch([cambios], [copia])) {
            this.hayCambios = true;
          } else {
            this.hayCambios = false;
          }
        });
      }
    },

    filtroProceso(data, filterString) {
      return [data].some(item => {
        return (
          item.nombre.toLowerCase().includes(filterString.toLowerCase()) ||
          item.zona.toLowerCase().includes(filterString.toLowerCase()) ||
          item.actividad.toLowerCase().includes(filterString.toLowerCase()) ||
          item.tarea.toLowerCase().includes(filterString.toLowerCase()) ||
          item.rutinario_peligro.toLowerCase().includes(filterString.toLowerCase())
        );
      });
    },

    filtroPeligro(data, filterString) {
      return data.some(item => {
        return (
          item.clasificacion.toLowerCase().includes(filterString.toLowerCase()) ||
          item.subclasificacion.toLowerCase().includes(filterString.toLowerCase()) ||
          item.descripcion.toLowerCase().includes(filterString.toLowerCase())
        );
      });
    },

    filtroCriterios(data, filterString) {
      return [data].some(item => {
        return (
          item.num_expuestos.toLowerCase().includes(filterString.toLowerCase()) ||
          item.peor_consecuencia.toLowerCase().includes(filterString.toLowerCase()) ||
          item.requisito_legal.toLowerCase().includes(filterString.toLowerCase())
        );
      });
    },

    async mostrar_controles_fuente(id_matriz) {
      NProgress.start();
      this.local_id_matriz_riesgo = id_matriz;
      this.fuente_checked = [];
      let fuente = "";

      const docRef = db.collection("matriz_riesgo").doc(id_matriz);
      await docRef.get().then((doc) => {
        if (doc.exists) {
          // ARRAY CON LAS FUENTES CHECKEADAS
          fuente = doc.data().em_c_fuente;
        }
      });

      if (Array.isArray(fuente)) {
        this.fuente_checked = fuente.map((i) => ` ${i}`).toString();
      } else {
        this.fuente_checked = fuente;
      }
      NProgress.done();
      NProgress.remove();
    },

    async mostrar_controles_medio(id_matriz) {
      NProgress.start();
      this.local_id_matriz_riesgo = id_matriz;
      this.medio_checked = [];
      let medio = "";

      const docRef = db.collection("matriz_riesgo").doc(id_matriz);
      await docRef.get().then((doc) => {
        if (doc.exists) {
          // ARRAY CON LOS MEDIOS CHECKEADOS
          medio = doc.data().em_c_medio;
        }
      });
      if (Array.isArray(medio)) {
        this.medio_checked = medio.map((i) => ` ${i}`).toString();
      } else {
        this.medio_checked = medio;
      }
      NProgress.done();
      NProgress.remove();
    },

    async mostrar_controles_individuo(id_matriz) {
      NProgress.start();
      this.local_id_matriz_riesgo = id_matriz;
      this.individuo_checked = [];
      let individuo = "";

      const docRef = db.collection("matriz_riesgo").doc(id_matriz);
      await docRef.get().then((doc) => {
        if (doc.exists) {
          // ARRAY CON LOS INDIVIDUOS CHECKEADOS
          individuo = doc.data().em_c_individuo;
        }
      });
      if (Array.isArray(individuo)) {
        this.individuo_checked = individuo.map((i) => ` ${i}`).toString();
      } else {
        this.individuo_checked = individuo;
      }
      NProgress.done();
      NProgress.remove();
    },

    async consultar_evaluacion_riesgo(
      id_matriz,
      class_btn_outline,
      class_btn_alerts
    ) {
      this.limpiar_variables();
      NProgress.start();
      const docRef = db.collection("matriz_riesgo").doc(id_matriz);
      await docRef
        .get()
        .then((doc) => {
          this.c_aceptabilidad = doc.data().em_aceptabilidad;
          if (this.c_aceptabilidad == "" || this.c_aceptabilidad == null) {
            this.c_aceptabilidad = "Pendiente";
            this.c_interpretacion = "Pendiente";
            this.c_interpretacion_nr = "Pendiente";

            this.c_nivel_eficiencia = null;
            this.c_nivel_exposicion = null;
            this.c_nivel_probabilidad = null;
            this.c_nivel_consecuencia = null;
            this.c_nivel_riesgo = null;
          } else {
            this.c_nivel_eficiencia = doc.data().em_nivel_eficiencia;
            this.c_nivel_exposicion = doc.data().em_nivel_exposicion;
            this.c_nivel_probabilidad = doc.data().em_nivel_probabilidad;
            this.c_nivel_consecuencia = doc.data().em_nivel_consecuencia;
            this.c_nivel_riesgo = doc.data().em_nivel_riesgo;
            this.c_interpretacion = doc.data().em_interpretacion;
            this.c_interpretacion_nr = doc.data().em_interpretacion_nr;
          }
          this.class_btn_outline = class_btn_outline;
          this.class_btn_alerts = class_btn_alerts;

          this.local_id_matriz_riesgo = id_matriz;
          $("#modal_evaluacion_riesgo").modal("show");
        })
        .catch((error) => {
          console.log(
            "Error al obtener la evaluación de riesgos de matriz_riesgos",
            error
          );
        });
      NProgress.done();
      NProgress.remove();
    },

    async consultar_medidas_intervencion_eliminacion(id_matriz) {
      NProgress.start();
      this.local_id_matriz_riesgo = id_matriz;
      this.cm_eliminacion_checked = [];
      let eliminacion = "";

      const docRef = db.collection("matriz_riesgo").doc(id_matriz);
      await docRef.get().then((doc) => {
        if (doc.exists) {
          // ARRAY CON LA ELIMINACIÓN CHECKEADA
          eliminacion = doc.data().em_eliminacion;
        }
      });
      if (Array.isArray(eliminacion)) {
        this.cm_eliminacion_checked = eliminacion
          .map((i) => ` ${i}`)
          .toString();
      } else {
        this.cm_eliminacion_checked = eliminacion;
      }
      NProgress.done();
      NProgress.remove();
    },

    async consultar_medidas_intervencion_sustitucion(id_matriz) {
      NProgress.start();
      this.local_id_matriz_riesgo = id_matriz;
      this.cm_sustitucion_checked = [];
      let sustitucion = "";

      const docRef = db.collection("matriz_riesgo").doc(id_matriz);
      await docRef.get().then((doc) => {
        if (doc.exists) {
          // ARRAY CON LA SUSTITUCIÓN CHECKEADA
          sustitucion = doc.data().em_sustitucion;
        }
      });
      if (Array.isArray(sustitucion)) {
        this.cm_sustitucion_checked = sustitucion
          .map((i) => ` ${i}`)
          .toString();
      } else {
        this.cm_sustitucion_checked = sustitucion;
      }
      NProgress.done();
      NProgress.remove();
    },

    async consultar_medidas_intervencion_controles(id_matriz) {
      NProgress.start();
      this.local_id_matriz_riesgo = id_matriz;
      this.cm_controles_checked = [];
      let controles = "";

      const docRef = db.collection("matriz_riesgo").doc(id_matriz);
      await docRef.get().then((doc) => {
        if (doc.exists) {
          if (doc.data().em_controles_ing) {
            // ARRAY CON LOS CONTROLES CHECKEADOS
            controles = doc.data().em_controles_ing;
          } else if (doc.data().em_control_ingenieria) {
            controles = doc.data().em_control_ingenieria;
          }
        }
      });
      if (Array.isArray(controles)) {
        this.cm_controles_checked = controles.map((i) => ` ${i}`).toString();
      } else {
        this.cm_controles_checked = controles;
      }
      NProgress.done();
      NProgress.remove();
    },

    async consultar_medidas_intervencion_controles_admin(id_matriz) {
      NProgress.start();
      this.local_id_matriz_riesgo = id_matriz;
      this.cm_controles_admin_checked = [];
      let controles_admin = "";

      const docRef = db.collection("matriz_riesgo").doc(id_matriz);
      await docRef.get().then((doc) => {
        if (doc.exists) {
          if (doc.data().em_controles) {
            // ARRAY CON LOS CONTROLES ADMINISTRATIVOS CHECKEADOS
            controles_admin = doc.data().em_controles;
          } else if (doc.data().em_controles_admin) {
            controles_admin = doc.data().em_controles_admin;
          }
        }
      });
      if (Array.isArray(controles_admin)) {
        this.cm_controles_admin_checked = controles_admin
          .map((i) => ` ${i}`)
          .toString();
      } else {
        this.cm_controles_admin_checked = controles_admin;
      }
      NProgress.done();
      NProgress.remove();
    },

    async consultar_medidas_intervencion_equipos(id_matriz) {
      NProgress.start();
      this.local_id_matriz_riesgo = id_matriz;
      this.cm_equipos_checked = [];
      let equipos = "";

      const docRef = db.collection("matriz_riesgo").doc(id_matriz);
      await docRef.get().then((doc) => {
        if (doc.exists) {
          if (doc.data().em_equipos) {
            // ARRAY CON LOS EQUIPOS CHECKEADOS
            equipos = doc.data().em_equipos;
          } else if (doc.data().em_epp) {
            equipos = doc.data().em_epp;
          }
        }
      });
      if (Array.isArray(equipos)) {
        this.cm_equipos_checked = equipos.map((i) => ` ${i}`).toString();
      } else {
        this.cm_equipos_checked = equipos;
      }
      NProgress.done();
      NProgress.remove();
    },

    // ELIMINAR PELIGRO MATRIZ PELIGRO
    eliminar_peligro(id_matriz) {
      Swal.fire({
        icon: "warning",
        title:
          "<h4 style='color: white'>¿Estás seguro de eliminar el peligro?</h4>",
        html: "<h5 style='color: white'>¡Se eliminará el peligro permanentemente!</h5>",
        background: "transparent",
        backdrop: `rgba(0,0,0,0.8)`,
        confirmButtonColor: "transparent",
        cancelButtonColor: "transparent",
        confirmButtonText:
          "<span style='color: white; border-color: #5cb85c' class='btn btn_semaforo'>Eliminar</span>",
        cancelButtonText:
          "<span style='color: white; border-color: #FF3333' class='btn btn_semaforo'>Cancelar</span>",
        reverseButtons: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          // ELIMINAR DE LA COLECCIÓN
          db.collection("matriz_riesgo").doc(id_matriz).delete();
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire({
            icon: "error",
            title: "<h4 style='color: white'>Operación Cancelada</h4>",
            timer: 2000,
            background: "transparent",
            backdrop: `rgba(0,0,0,0.8)`,
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
          });
        }
      });
    },

    // ELIMINAR PROCESO MATRIZ PELIGRO
    eliminar_proceso(id_proceso, id_zona, id_actividad, id_tareas) {
      Swal.fire({
        icon: "warning",
        title:
          "<h4 style='color: white'>¿Estás seguro de eliminar el proceso?</h4>",
        html: "<h5 style='color: white'>¡Se eliminarán todos los peligros asociados a este proceso permanentemente!</h5>",
        background: "transparent",
        backdrop: `rgba(0,0,0,0.8)`,
        confirmButtonColor: "transparent",
        cancelButtonColor: "transparent",
        confirmButtonText:
          "<span style='color: white; border-color: #5cb85c' class='btn btn_semaforo'>Eliminar</span>",
        cancelButtonText:
          "<span style='color: white; border-color: #FF3333' class='btn btn_semaforo'>Cancelar</span>",
        reverseButtons: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          db.collection("proceso").doc(id_proceso).delete();
          db.collection("zona").doc(id_zona).delete();
          db.collection("actividades").doc(id_actividad).delete();
          db.collection("tareas").doc(id_tareas).delete();

          this.$store.state.global_matriz_peligro_cliente.forEach((i) => {
            if (i.id_proceso == id_proceso) {
              i.lista_peligros.forEach((j) => {
                db.collection("matriz_riesgo").doc(j.id_matriz).delete();
              });
            }
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire({
            icon: "error",
            title: "<h4 style='color: white'>Operación Cancelada</h4>",
            timer: 2000,
            background: "transparent",
            backdrop: `rgba(0,0,0,0.8)`,
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
          });
        }
      });
    },

    async editar_peligro(id_matriz) {
      await this.$store.commit("mutation_preparacion_botones_tabla");
      this.$store.state.global_id_matriz_riesgo = id_matriz;
      this.$store.state.global_es_editar = true;

      const tap2 = document.getElementById("mip-tab");
      tap2.setAttribute("aria-selected", true);
      setTimeout(() => this.$router.push("/identificar_peligros"), 1000);
    },

    async nuevo_peligro(
      id_proceso,
      proceso_riesgo,
      id_zona,
      zona,
      id_actividad,
      actividad,
      id_tareas,
      tarea,
      rutinario_peligro
    ) {
      await this.$store.commit("mutation_preparacion_botones_tabla");

      this.$store.state.mip_id_proceso = id_proceso;
      this.$store.state.mip_id_zona = id_zona;
      this.$store.state.mip_id_actividad = id_actividad;
      this.$store.state.mip_id_tareas = id_tareas;

      this.$store.state.mip_proceso = proceso_riesgo;
      this.$store.state.mip_zona = zona;
      this.$store.state.mip_actividad = actividad;
      this.$store.state.mip_tarea = tarea;
      this.$store.state.mip_rutinario = rutinario_peligro;

      this.$store.state.global_id_matriz_riesgo = db
        .collection("matriz_riesgo")
        .doc().id;

      this.$store.state.global_nuevo_peligro = true;

      const tap2 = document.getElementById("mip-tab");
      tap2.setAttribute("aria-selected", true);
      this.$router.push("/identificar_peligros");
    },

    // LIMPIAR VARIABLES
    limpiar_variables() {
      this.local_id_matriz_riesgo = "";
      this.local_id_peligro = "";
      this.local_id_subcla = "";

      this.c_nivel_eficiencia = null;
      this.c_nivel_exposicion = null;
      this.c_nivel_probabilidad = 0;
      this.c_interpretacion = "";
      this.c_nivel_consecuencia = null;
      this.c_nivel_riesgo = 0;
      this.c_interpretacion_nr = 0;
      this.c_aceptabilidad = "";
      this.class_btn_alerts = {
        border: "",
        textAlign: "center",
        color: "",
      };
      this.class_btn_outline = {
        border: "",
        textAlign: "center",
        color: "",
      };

      this.c_num_expuestos = 0;
      this.c_peor_consecuencia = "";

      // LIMPIAR CONTROLES
      this.fuente_checked = [];
      this.medio_checked = [];
      this.individuo_checked = [];

      // LIMPIAR MEDIDAS DE INTERVENCIÓN
      this.cm_eliminacion = [];
      this.cm_eliminacion_checked = [];
      this.cm_sustitucion = [];
      this.cm_sustitucion_checked = [];
      this.cm_controles = [];
      this.cm_controles_checked = [];
      this.cm_controles_admin = [];
      this.cm_controles_admin_checked = [];
      this.cm_equipos = [];
      this.cm_equipos_checked = [];
    },

    query_peligro_vm(id_matriz) {
      let docRef = db.collection("matriz_riesgo").doc(id_matriz);

      docRef
        .get()
        .then((doc) => {
          if (doc.exists) {
            let rutinario = doc.data().em_rutinario;
            let class_btn_alerts = {
              border: "",
              textAlign: "center",
              color: "",
              width: "70%",
            };
            let class_btn_alerts_m = {
              border: "",
              textAlign: "center",
              color: "",
            };
            let class_btn_outline = {
              border: "",
              textAlign: "center",
              color: "",
            };
            let class_btn_outline_m = {
              border: "",
              textAlign: "center",
              color: "",
            };
            let em_aceptabilidad = "";
            let em_requisito_legal = doc.data().em_requisito_legal;
            if (em_requisito_legal == false) {
              em_requisito_legal = "No";
            } else if (em_requisito_legal == true) {
              em_requisito_legal = "Sí";
            }

            let em_eliminacion = [];
            let em_equipos = [];
            let em_sustitucion = [];
            let em_controles_ing = [];
            let em_controles_admin = [];
            let em_tarea = "";

            const array_efectos = doc.data().em_efecto_posible;
            const em_efecto_posible = array_efectos
              .map((i) => ` ${i}`)
              .toString();

            const array_tareas = doc.data().em_tarea;

            if (Array.isArray(array_tareas)) {
              em_tarea = array_tareas.map((i) => ` ${i}`).toString();
            } else {
              em_tarea = array_tareas;
            }

            const id_proceso = doc.data().em_id_proceso;

            if (rutinario == true) {
              rutinario = "Sí";
            } else {
              rutinario = "No";
            }
            em_aceptabilidad = doc.data().em_aceptabilidad;

            if (!em_aceptabilidad) {
              em_aceptabilidad = "Pendiente";
              class_btn_alerts.border = "3px solid #5bc0de";
              class_btn_alerts.color = "#5bc0de";
              class_btn_alerts_m.color = "#5bc0de";

              class_btn_outline.border = "3px solid #5bc0de";
              class_btn_outline.color = "#5bc0de";
            } else {
              if (doc.data().em_aceptabilidad == "No Aceptable") {
                class_btn_alerts.border = "3px solid #d9534f";
                class_btn_alerts.color = "#d9534f";
                class_btn_alerts_m.color = "#d9534f";
              } else if (
                doc.data().em_aceptabilidad ==
                "Aceptable con Control Específico"
              ) {
                class_btn_alerts.border = "3px solid #f0ad4e";
                class_btn_alerts.color = "#f0ad4e";
                class_btn_alerts_m.color = "#f0ad4e";
              } else if (doc.data().em_aceptabilidad == "Mejorable") {
                class_btn_alerts.border = "3px solid #5cb85c";
                class_btn_alerts.color = "#5cb85c";
              } else if (doc.data().em_aceptabilidad == "Aceptable") {
                class_btn_alerts.border = "3px solid #5cb85c";
                class_btn_alerts.color = "#5cb85c";
                class_btn_alerts_m.color = "#5cb85c";
              }

              if (doc.data().c_interpretacion == "Muy alto") {
                class_btn_outline.border = "3px solid #d9534f";
                class_btn_outline.color = "#d9534f";
                class_btn_outline_m.color = "#d9534f";
              } else if (doc.data().em_interpretacion == "Alto") {
                class_btn_outline.border = "3px solid #f0ad4e";
                class_btn_outline.color = "#f0ad4e";
                class_btn_outline_m.color = "#f0ad4e";
              } else if (doc.data().em_interpretacion == "Medio") {
                class_btn_outline.border = "3px solid #5cb85c";
                class_btn_outline.color = "#5cb85c";
                class_btn_outline_m.color = "#5cb85c";
              } else if (doc.data().em_interpretacion == "Bajo") {
                class_btn_outline.border = "3px solid #5cb85c";
                class_btn_outline.color = "#5cb85c";
                class_btn_outline_m.color = "#5cb85c";
              }
            }

            if (doc.data().em_eliminacion) {
              em_eliminacion = doc.data().em_eliminacion;
            }
            if (doc.data().em_sustitucion) {
              em_sustitucion = doc.data().em_sustitucion;
            }
            if (doc.data().em_controles_ing) {
              em_controles_ing = doc.data().em_controles_ing;
            } else if (doc.data().em_control_ingenieria) {
              em_controles_ing = doc.data().em_control_ingenieria;
            }
            if (doc.data().em_controles) {
              em_controles_admin = doc.data().em_controles;
            } else if (doc.data().em_controles_admin) {
              em_controles_admin = doc.data().em_controles_admin;
            }
            if (doc.data().em_equipos) {
              em_equipos = doc.data().em_equipos;
            } else if (doc.data().em_epp) {
              em_equipos = doc.data().em_epp;
            }

            this.id_proceso_movil = doc.data().em_id_proceso;
            this.id_zona_movil = doc.data().em_id_zona;
            this.id_actividad_movil = doc.data().em_id_acti;
            this.id_tareas_movil = doc.data().em_id_tareas;

            this.proceso_riesgo_movil = doc.data().em_proceso;
            this.zona_movil = doc.data().em_zona;
            this.actividad_movil = doc.data().em_actividad;
            this.tarea_movil = em_tarea;
            this.rutinario_peligro_movil = rutinario;

            this.id_matriz_movil = doc.id;
            this.id_peligro_movil = doc.data().em_id_peligro;
            this.clasificacion_movil = doc.data().em_clasificacion;
            this.id_subcla_movil = doc.data().em_id_subclasificacion;
            this.subclasificacion_movil = doc.data().em_tipo;
            this.descripcion_movil = doc.data().em_descripcion;

            this.id_efectos_posibles_movil = doc.data().em_id_efectos_posibles;
            this.efecto_posible_movil = em_efecto_posible;

            this.fuente_movil = doc.data().em_c_fuente;
            this.medio_movil = doc.data().em_c_medio;

            this.individuo_movil = doc.data().em_c_individuo;
            this.antecedente_movil = doc.data().em_antecedente;
            this.class_btn_outline_movil = class_btn_outline;
            this.class_btn_outline_m = class_btn_outline_m;
            this.class_btn_alerts_movil = class_btn_alerts;
            this.class_btn_alerts_m = class_btn_alerts_m;
            this.aceptabilidad_movil = em_aceptabilidad;

            this.num_expuestos_movil = doc.data().em_num_expuestos;
            this.peor_consecuencia_movil = doc.data().em_peor_consecuencia;
            this.requisito_legal_movil = em_requisito_legal;

            this.eliminacion_movil = em_eliminacion;
            this.sustitucion_movil = em_sustitucion;
            this.controles_ing_movil = em_controles_ing;
            this.controles_admin_movil = em_controles_admin;
            this.equipos_movil = em_equipos;
          } else {
            console.log("No se encontró la información.");
          }
        })
        .catch((error) => {
          console.log("Error al obtener la información:", error);
        });
    },
  },
};
</script>

<style>
.vgt-table {
  border-collapse: separate !important;
  border-spacing: 0;
  border-top: 0 !important;
  border: none !important;
}

.vgt-table thead {
  position: sticky;
  top: 0;
  z-index: 1;
}

.vgt-table th,
.vgt-table td {
  border-width: 0.5px !important;
}

.vgt-table thead th.sorting-desc button:before {
  border-top: 5px solid #e8640c;
}

.vgt-table thead th.sorting-asc button:after {
  border-bottom: 5px solid #e8640c;
}

.vgt-table td {
  font-size: 11pt !important;
  background: #ececec !important;
}

.vgt-table th {
  font-size: 11pt !important;
  text-align: left;
  color: white !important;
}

.vgt-table th.vgt-checkbox-col {
  color: #2f2f2f !important;
  border-bottom: 1px solid #dcdfe6;
  background: linear-gradient(#f3f3f3, #f3f3f3);
}

.vgt-table th.filter-th {
  color: #2f2f2f !important;
  border-bottom: 1px solid #dcdfe6;
  background: linear-gradient(#f3f3f3, #f3f3f3);
}

.vgt-global-search {
  background: linear-gradient(rgb(230, 231, 232), rgb(230, 231, 232));
}

.vgt-table th.vgt-checkbox-col input[type="checkbox"] {
  background-color: transparent;
  margin: 0;
  font: inherit;
  color: currentColor;
  width: 1.1em;
  height: 1.1em;
  border: 0.15em solid currentColor;
  border-radius: 0.15em;
  transform: translateY(-0.075em);
  accent-color: #e8640c;
}

.vgt-wrap__footer {
  background: rgb(230, 231, 232);
  border: none;
}

.footer__row-count__label {
  font-size: 12pt !important;
}

.vgt-table thead th {
  color: #2f2f2f !important;
  border-bottom: 1px solid #dcdfe6;
  background: linear-gradient(#f3f3f3, #f3f3f3);
}

.vgt-wrap__footer .footer__row-count__select {
  font-size: 11pt !important;
  padding: 0;
  margin-top: -6px;
  margin-left: 5px;
}

.vgt-wrap__footer .footer__navigation__page-btn span {
  font-size: 11pt;
}

.vgt-wrap__footer .footer__navigation>button:first-of-type {
  margin-right: 0px;
}

.vgt-wrap__footer .footer__navigation__page-btn .chevron.right::after {
  border-left: 6px solid #e8640c;
}

.vgt-wrap__footer .footer__navigation__page-btn .chevron.left::after {
  border-right: 6px solid #e8640c;
}

.footer__navigation__page-info {
  margin: 0 2px !important;
}

.vgt-wrap__footer .footer__row-count::after {
  content: "";
  display: block;
  position: absolute;
  height: 0;
  width: 0;
  right: 6px;
  top: 50%;
  margin-top: -1px;
  border-top: 0px solid #606266;
  border-left: 0px solid transparent;
  border-right: 0px solid transparent;
  border-bottom: none;
  pointer-events: none;
}

input.vgt-input,
select.vgt-select,
input.vgt-input:focus {
  outline: none !important;
  border: 1px solid #e8640c !important;
}

@media only screen and (max-width: 570px) {
  .vgt-wrap__footer .footer__navigation__page-btn {
    margin-left: -15px !important;
    margin-right: 15px !important;
  }

  .vgt-wrap__footer .footer__row-count__select {
    margin-right: auto;
  }

  .footer__navigation__page-info {
    width: 100%;
    margin: 10px 75px 15px 0px !important;
  }

  .vgt-pull-right {
    float: left !important;
  }

  .vgt-wrap__footer .footer__navigation__page-btn span {
    font-size: 9pt;
  }
}

.footer__navigation__page-info {
  font-size: 11pt !important;
}

.bg-success-changes {
  background-color: rgba(232, 100, 12, 0.3);
}
</style>

<style scoped>
@media only screen and (max-width: 768px) {
  .flex-column-changes {
    flex-direction: column !important;
  }
}
</style>